import { render, staticRenderFns } from "./CreateMainProjectDialog.vue?vue&type=template&id=67c644f0&scoped=true&"
import script from "./CreateMainProjectDialog.vue?vue&type=script&lang=js&"
export * from "./CreateMainProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateMainProjectDialog.vue?vue&type=style&index=0&id=67c644f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c644f0",
  null
  
)

export default component.exports